/*
 * THE PAPER IN THE BUILDER (2026-10-12; Daniel, 12 Oct: "the paper texture that we put on the website for these white
 * cards, like 'Please romaine calm', is not here in the preview").
 *
 * The same paper the design pages lay on their 3D card (assets/rd-card3d.js dressPaper, through window.PPPaper in
 * assets/card-paper.js): each of the builder's planes carries a .rdf-paper layer (snippets/builder-stage.liquid), dressed
 * here from that plane's OWN art, so it shows only where that art's ground is white and only on its white:
 *   CoverFront    the cover's art;
 *   CoverTop      the inside top's art, or the customer's words on it (the composite topRender made). NEVER when the
 *                 customer has put a photo there: the mask is "near-white pixels", and a photo has those too;
 *   CoverBottom   the ground the inside is printed on (CoverBottomGround), as rd-card3d does; the note is drawn over it;
 *   the panels    the design's border strip, masked and laid out as the strip is (configurator.js panelStrip), UNDER the
 *                 photo (card-paper.css: z-index -1 in the plane), so it only shows in the border round a picture.
 * The panels' blank backs are stock, always paper (card-paper.css, [data-pp-stage] .pp-plane--paper), as on the design
 * pages and the share page.
 *
 * STATIC: a layer is dressed when its art changes (a MutationObserver on src / style), never per frame. Each plane
 * already has a transform, so the darken blend and the mask are flattened inside the plane once, and the fold only moves
 * the planes. Web preview only; print is untouched, and nothing here goes near the cart.
 *
 * ?pppaper=0 turns it off for the tab (the builder exactly as before, for comparing); ?pppaper=1 back on.
 */
(function () {
  'use strict';
  var off = false;
  try {
    var q = new URLSearchParams(location.search).get('pppaper');
    if (q === '0') sessionStorage.setItem('pp_paper_off', '1');
    if (q === '1') sessionStorage.removeItem('pp_paper_off');
    off = sessionStorage.getItem('pp_paper_off') === '1';
  } catch (e) { /* storage off: on */ }
  if (off) { document.documentElement.setAttribute('data-pppaper', '0'); return; }

  function start() {
    var P = window.PPPaper, stage = document.querySelector('[data-builder-ui] [data-pp-stage]') || document.querySelector('[data-pp-stage]');
    if (!P || !stage) return;
    var urlOf = function (bg) { var m = /url\(["']?([^"')]+)["']?\)/.exec(bg || ''); return m ? m[1] : ''; };
    var shown = function (im) { return im && im.getAttribute('src') && im.style.display !== 'none' ? im.getAttribute('src') : ''; };
    var data = function () { try { return window.Alpine && Alpine.$data(stage); } catch (e) { return null; } };
    var dress = function (lay, src) { if (lay && lay.getAttribute('data-for') !== (src || '')) P.on(lay, src || ''); };

    var plane = function (n) { return stage.querySelector('[data-pp-plane="' + n + '"]'); };
    var front = plane('CoverFront'), top = plane('CoverTop'), note = plane('CoverBottom');
    var lay = function (pl) { return pl && pl.querySelector(':scope > .rdf-paper'); };
    var frontArt = front && front.querySelector('.pp-plane__art');
    var topArt = top && top.querySelector('.pp-plane__art');
    var ground = note && note.querySelector('.pp-plane__art--ground');
    var panels = [].slice.call(stage.querySelectorAll('.pp-plane--panel[data-pp-panel]'));

    function topSrc() {
      var src = shown(topArt);
      if (!src) return '';
      var c = data();
      // The customer's own photo on the inside top: no paper over a photograph (Daniel, 9 Oct: never grain over pictures).
      try { if (c && c.topActive && c.topActive() && c.topMode() === 'photo') return ''; } catch (e) { /* not the builder's */ }
      return src;
    }
    function covers() {
      dress(lay(front), shown(frontArt));
      dress(lay(top), topSrc());
      dress(lay(note), shown(ground));
    }
    function strips() {
      panels.forEach(function (el) {
        var l = lay(el), src = urlOf(el.style.backgroundImage);
        if (!l || l.getAttribute('data-for') === src) return;
        l.style.webkitMaskSize = l.style.maskSize = el.style.backgroundSize || '';
        l.style.webkitMaskPosition = l.style.maskPosition = el.style.backgroundPosition || '';
        P.on(l, src);
      });
    }
    // NOTHING PER FRAME. card-stage.js writes each plane's transform inline on every frame of a fold, so a
    // MutationObserver on the planes would run through the whole fold. The art is watched instead: the cover images'
    // src (an <img> is never written by the fold), and the strip through Alpine, which says when the design or the
    // border changes; the panels' style is read once Alpine has applied it.
    var later = function () { setTimeout(function () { covers(); strips(); }, 30); };
    var mo = new MutationObserver(covers);
    [frontArt, topArt, ground].forEach(function (im) { if (im) mo.observe(im, { attributes: true, attributeFilter: ['src', 'style'] }); });
    covers();
    strips();
    var tries = 0;
    (function hook() {
      var c = data();
      if (!c || typeof c.designArt !== 'function' || !c.card || !window.Alpine || !Alpine.effect) {
        if (++tries < 200) setTimeout(hook, 100);
        return;
      }
      Alpine.effect(function () {
        c.designArt('Strip'); void c.card.border; void c.topPreviewUrl;
        try { c.topMode(); c.topActive(); } catch (e) { /* not offered */ }
        later();
      });
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
